import { Link } from 'react-router-dom'

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-lg font-bold text-text-primary mb-3">{title}</h2>
    <div className="text-sm text-text-secondary leading-relaxed space-y-3">{children}</div>
  </div>
)

export const TermsOfService = () => (
  <div className="min-h-screen bg-background">
    <nav className="fixed top-0 inset-x-0 z-40 bg-background/90 backdrop-blur border-b border-border">
      <div className="max-w-3xl mx-auto px-4 h-14 flex items-center justify-between">
        <Link to="/" className="font-bold text-primary text-lg tracking-tight">DoorChart</Link>
        <Link to="/login" className="text-sm text-text-secondary hover:text-text-primary">Sign in</Link>
      </div>
    </nav>

    <div className="max-w-3xl mx-auto px-4 pt-24 pb-16">
      <h1 className="text-3xl font-extrabold text-text-primary mb-2">Terms of Service</h1>
      <p className="text-sm text-text-muted mb-10">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <Section title="Acceptance of Terms">
        <p>By creating a DoorChart account or using our services, you agree to these Terms of Service. If you do not agree, please do not use DoorChart.</p>
      </Section>

      <Section title="Description of Service">
        <p>DoorChart is a family organisation platform providing shared calendars, task management, shopping lists, meal planning, budgeting tools, and more. We offer both free and paid subscription plans.</p>
      </Section>

      <Section title="Accounts and Households">
        <p>You are responsible for maintaining the security of your account credentials. Each account belongs to a household. You may invite other household members; you are responsible for their use of the service.</p>
        <p>You must be at least 13 years old to create an account. Do not create accounts on behalf of minors without parental consent.</p>
      </Section>

      <Section title="Acceptable Use">
        <p>You agree not to use DoorChart to:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Upload unlawful, harmful, or abusive content</li>
          <li>Attempt to gain unauthorised access to other households' data</li>
          <li>Reverse engineer or exploit the service</li>
          <li>Violate any applicable laws or regulations</li>
        </ul>
      </Section>

      <Section title="Subscriptions and Billing">
        <p>Paid plans are billed in advance on a monthly, annual, or one-time basis via Stripe. All paid plans include a 7-day free trial for new subscribers.</p>
        <p>You may cancel your subscription at any time. Cancellation takes effect at the end of the current billing period. We do not offer refunds for partial periods.</p>
        <p>We reserve the right to change pricing with 30 days' advance notice.</p>
      </Section>

      <Section title="Data and Privacy">
        <p>Your use of DoorChart is also governed by our <Link to="/privacy" className="text-primary underline">Privacy Policy</Link>. You retain ownership of all data you create within the service.</p>
      </Section>

      <Section title="Availability">
        <p>We aim for high availability but do not guarantee 100% uptime. We are not liable for any loss of data or business caused by service interruptions.</p>
      </Section>

      <Section title="Termination">
        <p>We may suspend or terminate accounts that violate these terms. You may delete your account at any time from Settings → Profile.</p>
      </Section>

      <Section title="Limitation of Liability">
        <p>To the maximum extent permitted by law, DoorChart is provided "as is" without warranties of any kind. We are not liable for indirect, incidental, or consequential damages.</p>
      </Section>

      <Section title="Changes to Terms">
        <p>We may update these terms. Continued use after changes constitute acceptance. We will provide notice of material changes.</p>
      </Section>

      <Section title="Contact">
        <p>Questions? Email <a href="mailto:legal@doorchart.com" className="text-primary underline">legal@doorchart.com</a>.</p>
      </Section>
    </div>

    <footer className="py-8 px-4 border-t border-border">
      <div className="max-w-3xl mx-auto flex items-center gap-4 text-xs text-text-muted">
        <Link to="/"        className="hover:text-text-primary">Home</Link>
        <Link to="/privacy" className="hover:text-text-primary">Privacy Policy</Link>
        <Link to="/help"    className="hover:text-text-primary">Help Center</Link>
        <a href="mailto:hello@doorchart.com" className="hover:text-text-primary">Contact</a>
      </div>
    </footer>
  </div>
)
